module.exports = __webpack_public_path__ + "img/Img_claro.e0f79659.svg";